/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="54.57"
        height="50.28"
        viewBox="0 0 54.57 50.28"
        version="1.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M24.53 12.19h4.81v-4h-4.81Zm5 16.14h2.6v2.76h-9.66v-2.76h2.61V17.87h-2.61V15h7Z"
          className="icon-fill icon-accent"/><path
          fill="#0e497b"
          d="M6.59 2A4.59 4.59 0 0 0 2 6.59v26.08a4.52 4.52 0 0 0 4.47 4.57h29.28a1 1 0 0 1 .72.3l9.19 9.27v-8.56a1 1 0 0 1 1-1h1.28a4.59 4.59 0 0 0 4.57-4.57V6.59A4.59 4.59 0 0 0 47.94 2Zm40.16 48.28A1 1 0 0 1 46 50L35.36 39.26H6.59A6.52 6.52 0 0 1 0 32.81V6.59A6.6 6.6 0 0 1 6.59 0H48a6.6 6.6 0 0 1 6.59 6.59v26.08A6.6 6.6 0 0 1 48 39.26h-.23v10a1 1 0 0 1-.63.93 1 1 0 0 1-.39.08Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'InformationWordBubbleIcon';

export default Icon;
